// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnlinkEntityIntegrationMutationVariables = Types.Exact<{
  entityId: Types.Scalars['ID']['input'];
}>;


export type UnlinkEntityIntegrationMutation = { __typename?: 'Mutation', updateEntity: { __typename?: 'Entity', id: string, addeparLinkedToNongrantorEntity?: boolean | null, groupIntegrationAssetValues: boolean, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, integrationID: string }> | null } };

export const Operations = {
  Mutation: {
    UnlinkEntityIntegration: 'UnlinkEntityIntegration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UnlinkEntityIntegrationDocument = gql`
    mutation UnlinkEntityIntegration($entityId: ID!) {
  updateEntity(
    input: {id: $entityId, update: {clearIntegrationEntities: true, clearAddeparLinkedToNongrantorEntity: true, groupIntegrationAssetValues: true}}
  ) {
    id
    integrationEntities {
      id
      integrationID
    }
    addeparLinkedToNongrantorEntity
    groupIntegrationAssetValues
  }
}
    `;
export type UnlinkEntityIntegrationMutationFn = Apollo.MutationFunction<UnlinkEntityIntegrationMutation, UnlinkEntityIntegrationMutationVariables>;

/**
 * __useUnlinkEntityIntegrationMutation__
 *
 * To run a mutation, you first call `useUnlinkEntityIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkEntityIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkEntityIntegrationMutation, { data, loading, error }] = useUnlinkEntityIntegrationMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useUnlinkEntityIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkEntityIntegrationMutation, UnlinkEntityIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkEntityIntegrationMutation, UnlinkEntityIntegrationMutationVariables>(UnlinkEntityIntegrationDocument, options);
      }
export type UnlinkEntityIntegrationMutationHookResult = ReturnType<typeof useUnlinkEntityIntegrationMutation>;
export type UnlinkEntityIntegrationMutationResult = Apollo.MutationResult<UnlinkEntityIntegrationMutation>;
export type UnlinkEntityIntegrationMutationOptions = Apollo.BaseMutationOptions<UnlinkEntityIntegrationMutation, UnlinkEntityIntegrationMutationVariables>;